import { Button, Icon } from '@iwoca/orion';
import styles from './FundingStepActionButton.module.css';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';

export const FundingStepActionButton = ({
    status,
    handleFundingStepAction,
    actionMessage,
    pendingMessage
}: {
    status: TFundingRequirementsSteps['0']['status'];
    handleFundingStepAction: () => void;
    actionMessage: any;
    pendingMessage: any;
}) => {
    switch (status) {
        case 'COMPLETED':
            return (
                <Icon
                    icon="checkCircleFilled"
                    height="24"
                    width="24"
                    fill="rgba(0, 77, 51, 1)"
                    className={styles.actionIcon}
                    xlinkTitle="checked"
                />
            );
        case 'PENDING':
            return (
                <Button variant="primary" disabled>
                    {pendingMessage}
                </Button>
            );
        default:
            return (
                <Button
                    variant="primary"
                    onClick={() => handleFundingStepAction()}
                >
                    {actionMessage}
                </Button>
            );
    }
};
